<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Email Verification</h1>
              <p class="text-lead text-white">{{message ? message : "Please verify your email to continue."}}</p>
            </div>
          </div>
          <div v-if="!loading">
            <div v-if="!sentEmail">
              <div class="text-center mb-4">
                  <h3 class="text-lead text-white">Didn't get an email?</h3>
              </div>
              <div class="text-center">
                  <b-button size="sm" variant="secondary" @click="resendEmail()">Resend</b-button>
              </div>
            </div>
            <!-- <div v-else>
              <div class="text-center mb-4">
                  <h3 class="text-lead text-white">Already verified?</h3>
              </div>
              <div class="text-center">
                  <b-button size="sm" variant="secondary" @click="refreshStatus()">Refresh</b-button>
              </div>
            </div> -->
          </div>
          <div v-else>
            <b-spinner variant="white" class="p-3"></b-spinner>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import { getInstance } from '#/auth';
import { EmailVerificationResendRequest } from '#/protobuf/service_user_pb';

export default {
  data() {
    return {
      message: undefined,
      sentEmail: false,
      loading: false,
    };
  },
  computed: {
  },
  methods: {
    async resendEmail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const request = new EmailVerificationResendRequest();
      this.$store.dispatch('user/resendVerificationEmail', request).then((response) => {
        console.log('resent verification email.', response);
        this.message = 'A new verification email has been sent.';
        this.sentEmail = true;
      }).catch((error) => {
        console.log('caught error on resend email', error);
        // TODO: better error messages
        this.message = 'Ooops. Something went wrong.';
      }).finally(() => {
        this.loading = false;
      });
    },
    async refreshStatus() {
      console.log('refreshing status');
    },
  },
};
</script>
<style>

</style>
